import { Link } from "react-router-dom";
import { ChevronLeft, Home } from "lucide-react";
import { SharePageButton } from "@/components/SharePageButton";

/**
 * Page shell used by /register, /waitlist, /sponsor, /rules.
 * Provides a back-to-home header + ombre wrapper so the embedded
 * homepage section keeps its existing styling without modification.
 */
export default function PageLayout({ title, kicker, children, testid, shareMessage }) {
  return (
    <div data-testid={testid} className="min-h-screen bg-[#fff4fa]">
      <header className="sticky top-0 z-40 bg-white/95 backdrop-blur-md border-b border-[#f0e1e8]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link
            to="/"
            data-testid="page-back-home"
            className="flex items-center gap-2.5 group"
          >
            <img
              src="/logo-sm.png"
              alt="Queenz Like Me"
              className="h-11 w-11 rounded-full object-cover shadow-md ring-2 ring-[#d4af37]/50 group-hover:ring-[#d4af37] transition-all"
            />
            <div className="leading-none hidden sm:block">
              <div className="flex items-baseline gap-1">
                <span className="font-script text-2xl gold-text">
                  Queen<span className="font-display not-italic">z</span>
                </span>
                <span className="font-display text-base font-semibold text-[#7d289b]">
                  Like Me
                </span>
              </div>
              <p className="text-[10px] uppercase tracking-[0.18em] text-[#d62288] font-semibold mt-0.5">
                Girls Mentoring
              </p>
            </div>
          </Link>

          <Link
            to="/"
            data-testid="page-home-link"
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#7d289b] hover:text-[#d62288] transition-colors"
          >
            <ChevronLeft className="h-4 w-4" />
            <Home className="h-4 w-4 sm:hidden" />
            <span className="hidden sm:inline">Back to home</span>
          </Link>
        </div>
      </header>

      {(title || kicker || shareMessage) && (
        <section className="pt-12 pb-4 text-center max-w-3xl mx-auto px-6">
          {kicker && (
            <p className="font-script text-3xl text-[#7a5a14] drop-shadow-[0_1px_0_rgba(255,255,255,0.6)] mb-2">
              {kicker}
            </p>
          )}
          {title && (
            <h1 className="font-display text-3xl sm:text-5xl font-bold text-[#4a1466]">
              {title}
            </h1>
          )}
          {shareMessage && (
            <div className="mt-5 flex justify-center">
              <SharePageButton message={shareMessage} testid={`${testid}-share`} />
            </div>
          )}
        </section>
      )}

      <main>{children}</main>
    </div>
  );
}
